/**
 * @todo Удалить файл
 * @description Данный функционал появился в задаче CD-246518, будет удалён в задаче CD-245127
 * Если переходим на базулу, то покрыть тестами
 * Если остаёмся на адфоксе, то удалить директорию полностью
 */

import { BuzzoolaBannerWithHide, BuzzoolaBannerWithHideProps } from '@cian/buzzoola-component';
import React, { FC } from 'react';

import { useAdfoxPuids } from '../AdfoxBanner/external/context/AdfoxContext/internal/hooks/useAdfoxParams';

type BuzzoolaBannerContainerProps = Omit<BuzzoolaBannerWithHideProps, 'thirdPartyRequestParams'>;

export const BuzzoolaBannerContainer: FC<BuzzoolaBannerContainerProps> = props => {
  const puids = useAdfoxPuids();

  return <BuzzoolaBannerWithHide {...props} thirdPartyRequestParams={puids} />;
};
